<div class="claims--bug sticky" (click)="scrollToElement(target)" [title]="title" [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}"></div>